module.exports = __webpack_public_path__ + "media/images/app/collections/collection-couture-d8f0fbf3d6aeb8be43aeaeee61a5a144.webp";